import { FormEvent, useState } from 'react'
import * as S from './styles'
import imgImovel from '../../assets/images/imgImovel.png'
import Button from '../Button'

const Modal = () => {
  const [modalAberto, setModalAberto] = useState(false)

  const abrirModal = (e: FormEvent) => {
    e.preventDefault()
    setModalAberto(true)
  }

  const fecharModal = () => {
    setModalAberto(false)
  }

  return (
    <>
      <form onSubmit={abrirModal}>
        <Button width="all">Abrir Modal</Button>
      </form>
      <S.Modal className={modalAberto ? 'is-visible' : ''}>
        <S.Overlay onClick={() => fecharModal()} />
        <S.ModalContainer>
          <header>
            <p onClick={() => fecharModal()} title="Fechar modal">
              X
            </p>
          </header>
          <body>
            <img src={imgImovel} alt="Imagem Imóvel" />
          </body>
        </S.ModalContainer>
      </S.Modal>
    </>
  )
}

export default Modal
